import { TApplicationState } from 'shared/types/redux';

export function selectIsWidgetOpen(state: TApplicationState): boolean {
  return state.auth.isWidgetOpen;
}
